<h2 mat-dialog-title>Save Transform Pipeline</h2>

<mat-dialog-content>
    <mat-form-field>
        <input matInput
                placeholder="Transform Pipeline Name"
               [(ngModel)]="name">
    </mat-form-field>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button (click)="save()" color="primary" mat-raised-button tabindex="-1">SAVE</button>
    <button (click)="cancel()" mat-raised-button mat-dialog-close tabindex="-1">CANCEL</button>
</mat-dialog-actions>